import { updatesData } from '@/mocks/homeData';

const zoneColors: Record<string, string> = {
  '黑料一区': 'bg-primary-100 text-primary-700',
  '黑料二区': 'bg-accent-100 text-accent-700',
  '每日大赛': 'bg-secondary-100 text-secondary-700',
  '站务公告': 'bg-background-200 text-foreground-600',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            {updatesData.title}
          </h2>
          <p className="text-sm text-foreground-600">实时追踪51黑料网最新分区内容更新</p>
        </div>
        <div className="relative">
          <div className="absolute left-4 top-0 bottom-0 w-px bg-background-300/60 hidden md:block"></div>
          <div className="space-y-4">
            {updatesData.items.map((item, idx) => (
              <div key={idx} className="relative flex items-start gap-4 pl-0 md:pl-10">
                <div className="hidden md:flex absolute left-0 top-2 w-8 h-8 flex items-center justify-center">
                  <div className="w-2.5 h-2.5 bg-primary-500 rounded-full border-2 border-background-50"></div>
                </div>
                <div className="flex-1 bg-background-100 rounded-xl p-4 md:p-5">
                  <div className="flex items-center gap-2 mb-2 flex-wrap">
                    <span className={`px-2 py-0.5 text-xs font-medium rounded ${zoneColors[item.zone] || 'bg-background-200 text-foreground-600'}`}>
                      {item.zone}
                    </span>
                    <span className="text-xs text-foreground-500">
                      {item.date} {item.time}
                    </span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">{item.content}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}